import styles from '../css/Sidebar.module.scss';
import logo from '../images/logo50.png';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from './Auth';

const Sidebar = () => {
  const { logout } = useContext(AuthContext);
  return (
    <div className={styles.Sidebar}>
      <Link to="/">
        <img src={logo} alt="app logo" />
      </Link>
      <div>
        <Link to="/devices/">
          <i className="fas fa-tablet-alt" />
        </Link>
        <br />
        <Link to="/api/">
          <i className="fas fa-network-wired" />
        </Link>
        <br />
        <Link to="/plugins/">
          <i className="fas fa-puzzle-piece" />
        </Link>
        <br />
        <i
          className="fas fa-sign-out-alt"
          onClick={() => {
            logout();
          }}
        />
      </div>
    </div>
  );
};

export default Sidebar;
